import { useState } from 'react';

// Bật/tắt hiệu ứng nền theo mùa/thời tiết. Lưu localStorage + báo cho SeasonalBackground.
export default function FxToggle() {
  const [on, setOn] = useState(() => localStorage.getItem('ft-fx') !== 'off');

  function toggle() {
    const v = !on;
    setOn(v);
    localStorage.setItem('ft-fx', v ? 'on' : 'off');
    window.dispatchEvent(new Event('ft-fx-change'));
  }

  return (
    <button
      className="btn ghost sm"
      style={{ width: '100%', marginTop: 8 }}
      onClick={toggle}
      title="Bật/tắt hiệu ứng nền theo mùa & thời tiết"
    >
      <i className={`ti ${on ? 'ti-sparkles' : 'ti-square'}`} aria-hidden="true" /> Hiệu ứng nền: {on ? 'Bật' : 'Tắt'}
    </button>
  );
}
